import { Button, Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { useMedicalRecordManagementContext } from '../contexts/MedicalRecordManagementContext'

export default function MedicalRecordManagementStatus() {
  const { t } = useTranslation()

  const {
    filter: { status },
    setStatus
  } = useMedicalRecordManagementContext()

  return (
    <Flex gap={'4'}>
      <Button
        w={'fit-content'}
        borderRadius={'full'}
        py="1"
        bgColor={
          status === 'WAITING_FOR_REVIEW'
            ? 'custom.orange.light'
            : 'custom.gray.800'
        }
        color={
          status === 'WAITING_FOR_REVIEW'
            ? 'custom.orange.dark'
            : 'custom.gray.400'
        }
        size={'sm'}
        px="3"
        textAlign={'center'}
        fontWeight={'500'}
        fontSize={'0.875rem'}
        onClick={() => setStatus('WAITING_FOR_REVIEW')}
      >
        {t(
          'medicalRecordManagement.filter.options.status.options.WAITING_FOR_REVIEW'
        )}
      </Button>
      <Button
        w={'fit-content'}
        borderRadius={'full'}
        py="1"
        bgColor={status === 'SENT' ? 'custom.blue.light' : 'custom.gray.800'}
        color={status === 'SENT' ? 'custom.blue.darker' : 'custom.gray.400'}
        size={'sm'}
        px="3"
        textAlign={'center'}
        fontWeight={'500'}
        fontSize={'0.875rem'}
        onClick={() => setStatus('SENT')}
      >
        {t('medicalRecordManagement.filter.options.status.options.SENT')}
      </Button>
      <Button
        w={'fit-content'}
        borderRadius={'full'}
        py="1"
        bgColor={status === 'EXPIRED' ? 'custom.red.light' : 'custom.gray.800'}
        color={status === 'EXPIRED' ? 'custom.red.dark' : 'custom.gray.400'}
        size={'sm'}
        px="3"
        textAlign={'center'}
        fontWeight={'500'}
        fontSize={'0.875rem'}
        onClick={() => setStatus('EXPIRED')}
      >
        {t('medicalRecordManagement.filter.options.status.options.EXPIRED')}
      </Button>
      <Button
        w={'fit-content'}
        borderRadius={'full'}
        py="1"
        bgColor={
          status === 'COMPLETE' ? 'custom.green.light' : 'custom.gray.800'
        }
        color={status === 'COMPLETE' ? 'custom.green.dark' : 'custom.gray.400'}
        size={'sm'}
        px="3"
        textAlign={'center'}
        fontWeight={'500'}
        fontSize={'0.875rem'}
        onClick={() => setStatus('COMPLETE')}
      >
        {t('medicalRecordManagement.filter.options.status.options.COMPLETE')}
      </Button>
    </Flex>
  )
}
